import { ShenCeUrl } from '@/httpService/API';
let sensors = require('sa-sdk-javascript');

// 注册“神策”数据埋点
export const playSensors = function (params) {
    let point_type = `${ShenCeUrl}/p/dc/sa.gif?project=grt_point`;
    // searchObj = urlSearchParamsToObject(window.location.href);
    sensors.init({
        // server_url: `${requestHost}/p/dc/sa.gif?project=grt_point&point_type=video_point`,
        server_url: point_type,
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: 'beacon',
        heatmap: {
            //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: 'not_collect',
            //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'not_collect'
        }
    });
    // 注册公共属性
    // 注册公共属性
    if (!params.tenant_id) {
        alert('租户丢失，请刷新页面');
        return false;
    }
    sensors.registerPage({
        uid: params.uid || '',
        platform_id: 600, //学习公社6.0
        client_type: 'web',
        tenant_id: params.tenant_id,
        is_login_state: params.isLogin || true, //登录状态
        portal_id: params.portal_id
        // nav_id: params.nav_id || searchObj.nav_id
    });
};

// 登录埋点
export const loginBurialPoint = function (params) {
    playSensors(params);
    sensors.track('login', params);
    console.log(params);
};
